var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscoverElectricVehicles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 66,
    viewBox: "0 0 54 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.76 3.03C47.16 1.26 45.48 0 43.5 0H10.5C8.52 0 6.87 1.26 6.24 3.03L0 21V45C0 46.65 1.35 48 3 48H6C7.65 48 9 46.65 9 45V42H45V45C45 46.65 46.35 48 48 48H51C52.65 48 54 46.65 54 45V21L47.76 3.03ZM10.5 33C8.01 33 6 30.99 6 28.5C6 26.01 8.01 24 10.5 24C12.99 24 15 26.01 15 28.5C15 30.99 12.99 33 10.5 33ZM43.5 33C41.01 33 39 30.99 39 28.5C39 26.01 41.01 24 43.5 24C45.99 24 48 26.01 48 28.5C48 30.99 45.99 33 43.5 33ZM6 18L10.5 4.5H43.5L48 18H6Z",
    fill: "#0F3E5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 57H24V51L42 60H30V66L12 57Z",
    fill: "#0F3E5F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverElectricVehicles);
export default __webpack_public_path__ + "static/media/discover-electric-vehicles.07e6934f846b75667735972eec11bac6.svg";
export { ForwardRef as ReactComponent };